export default "<div class=\"upload-file\">\n  <h3 class=\"py-1\" mat-dialog-title>{{ 'result.result_dialog.document_signed' | translate }}</h3>\n</div>\n"